export default __webpack_public_path__ + "static/media/dashboard.1205c42d.svg";